// extracted by mini-css-extract-plugin
module.exports = {"toggle":"styles_toggle__fRDBQ","toggle--light":"styles_toggle--light__Y_utc","toggle__button":"styles_toggle__button__W5AeH","toggle--active":"styles_toggle--active__xBkQ7"};